import { BrandModel } from './brand.api';

export class BrandUtility {
    static areYourInformationFieldsFilled = (brand: BrandModel | undefined) =>
        !!(
            brand?.legalName?.value &&
            brand?.streetAddress?.value &&
            brand?.city?.value &&
            brand?.state?.value &&
            brand?.zipCode?.value &&
            brand?.country?.value &&
            brand?.phone?.value &&
            brand?.email?.value &&
            brand?.primaryContactFirstName?.value &&
            brand?.primaryContactLastName?.value &&
            brand?.website?.value
        );
}
